import { Ref } from "react"
import { EntityPopover, EntityPopoverHandle } from "../../../components/ui/popover/EntityPopover"
import { BookCheck } from "lucide-react"
import { AccountProductInfo } from "../logic/slice";
import LoanAccountPopoverRow from "./LoanAccountPopoverRow";

export interface CreditAccountPopoverProps {
    creditAccounts: AccountProductInfo[];
    ref?: Ref<EntityPopoverHandle>;
}

export const CrediAccountsPopover: React.FC<CreditAccountPopoverProps> = ({creditAccounts, ref}) => {
    return (
        <EntityPopover
            ref={ref}
            icon={<BookCheck width={16} />}
            title="Loan Accounts"
            items={creditAccounts.map((account, index) => ({
                content: <LoanAccountPopoverRow account={account} showDivider={index > 0} />,
                copyValue: account.ext_account_number,
            }))}
        />
    )
}